<nav *ngIf="mode === dialogMode.Basic" class="toolbar navbar navbar-light">
    <form class="form-inline" autocomplete="off">
        <button class="btn btn-outline-success" type="button" (click)="onAdd()" title="Nuevo"><i class="sprite home"></i> Nuevo </button>
        <button *ngIf="!visibilitySpinner" type="button" class="btn btn-outline-success" [disabled]="!exportIsAvailable"  (click)="onExportExcel()" title="Exportar"><i class="fa fa-file-excel-o"></i> Exportar </button>
        <button *ngIf="visibilitySpinner" type="button" [disabled]="true" class="btn btn-outline-success">
            <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
            Exportando
        </button>
    </form>
</nav>

<div class="container-fluid container-list">

    <app-codigoconfeccion-filter
        [listActivos]="listActivos" [mode]="mode"
        [lastFilter]="payload" [provincias]="provincias" [municipios]="municipios"
        (provinciaSelected)="onProvinciaSelected($event)"
        (search)="onSearch($event)" (cleanForm)="onReset($event)"></app-codigoconfeccion-filter>

    <app-codigoconfeccion-list *ngIf="searching" 
        [result]="result" [lastFilter]="payload"
        [mode]="mode" [readonly]="readonly"
        (search)="onSearchLazy($event)" (edit)="onEdit($event)" (view)="onView($event)" (delete)="onDelete($event)" (authorize)="onAuthorize($event)" (selectedAlmacenes)="onSelectedAlmacenes($event)">
    </app-codigoconfeccion-list>
    
</div>
